// eslint-disable-next-line import/no-unresolved
const { debounce } = window.BAO.Utils

class ProductZoomLightbox extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.slideEls || this.slideEls.length < 1) return
    this.lightboxCarousel = this.initializeCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleResize = this.handleResize.bind(this)
    const debouncedHandleResize = debounce(this.handleResize, 250)
    this.listeners.add(window, 'resize', debouncedHandleResize.bind(this))

    this.listeners.add(this.prevEl, 'click', this.handleArrowClick.bind(this))
    this.listeners.add(this.nextEl, 'click', this.handleArrowClick.bind(this))

    this.externalTriggers.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.handleCarouselUpdate.bind(this))
    })
  }

  initializeCarousel () {
    // eslint-disable-next-line no-undef
    return new KeenSlider(this.slidesEl, {
      mode: 'snap',
      loop: true,
      slides: {
        perView: 1,
        spacing: 0,
      },
      selector: this.els?.slide?.selector,
      created: instance => {
        this.classList.add('prd-ZoomLightbox-active')
      },
    })
  }

  handleArrowClick (e) {
    const direction = e.target.dataset.productZoomLightboxEl
    if (!direction) return

    if (direction === 'prev') {
      this.lightboxCarousel.prev()
    } else {
      this.lightboxCarousel.next()
    }
  }

  handleCarouselUpdate (e) {
    setTimeout(() => {
      const slideIndex = e.target.closest('.prd-MediaCarousel_Slide').dataset
        .index

      this.lightboxCarousel.update('', Number(slideIndex - 1))
    }, 0)
  }

  handleResize (e) {
    if (window.innerWidth >= 901) {
      this.dataset.autoplay = false
      this.autoplay(false)
    } else {
      this.dataset.autoplay = true
      this.autoplay(true)
    }
  }

  autoplay (run) {
    clearInterval(this.interval)

    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, 3000)
  }

  get slidesEl () {
    return this.els?.slides?.element
  }

  get slideEls () {
    return this.els?.slide?.elements
  }

  get prevEl () {
    return this.els?.prev?.element
  }

  get nextEl () {
    return this.els?.next?.element
  }

  get externalTriggers () {
    return this.externalEls?.trigger?.elements
  }
}

if (!customElements.get('product-zoom-lightbox')) {
  customElements.define('product-zoom-lightbox', ProductZoomLightbox)
}
